import React from "react";
import OtherRankingRegister from "../OtherRankingRegister";

import {
    TOTAL_GITHUB_USERS,
    TOTAL_STACKOVERFLOW_USERS,
  } from "../../utils/totalNumberUsers";

import {
    DISPLAY_STRING_GH,
    DISPLAY_STRING_SO
    } from "../../utils/serviceName";
  
const RecruiterOrEmployerSalesTitleText = () => {
    return `Employ developers? Wish you could get an instant technical & soft skills assessment of a candidate?`;
};

const RecruiterOrEmployerSalesText = () => {
    return <>
        <p className="p-other-desc">
        TechieRank is a novel pre-employment developer assessment platform.
        <br/><br/>
        Gain a strategic hiring advantage by uncovering hidden data points about your candidates by checking their ranking and soft skills on {DISPLAY_STRING_GH} or{" "} {DISPLAY_STRING_SO}.
        <br/><br/>
        TechieRank makes it quick and easy (even as a non techincal applicant assessor) to instantly spot your diamond in the rough applicants!
        <br/><br/>
        <img src="/techierank.gif" alt="Check any developer's tech and soft skills" style={{width: "80%"}}/>
        <br/>
        <br/>
        Developers do not need to be members of our service - it works on any of the {TOTAL_GITHUB_USERS + TOTAL_STACKOVERFLOW_USERS} million developers with a public {DISPLAY_STRING_GH} or{" "} {DISPLAY_STRING_SO} profile!
        <br/><br/>
        {/* Do your traditional candidate screening processes rely on outdated Cover Letters, CVs & LinkedIn profiles resulting in diamond in the rough developers slipping through your fingers?
        <br/><br/> */}
        Studies show many great developers (often from more diverse backgrounds) don't have good CVs or LinkedIn profiles but have proof of tech and soft skills (such as ability to solve problems themselves, communication skills e.t.c) on {DISPLAY_STRING_GH} or{" "} {DISPLAY_STRING_SO} that TechieRank uncovers for you.
    <br/></p>
    </>;
};

const NonLoggedView = function ({navigateToRegister}) {

return <>
    <section className="other-ranking">
    <div className="other-ranking-heading">
        {/* <h3>Do all developer applicants look the same?</h3> */}
        <h3>{RecruiterOrEmployerSalesTitleText()}</h3>
    </div>

    <div className="other-ranking-details">
            
        {RecruiterOrEmployerSalesText()}
        {/* <p className="p-other-desc"><br/><a style={{textDecoration: "underline"}} onClick={navigateToRegister}>GET STARTED NOW FOR FREE</a><br/><br/></p> */}
        <p className="p-other-desc">
        <br/>Check 5 of your applicants free - it just takes 1 minute:
        </p>
            {/* <p className="p-other-desc"><br/>THEN <a style={{textDecoration: "underline"}} href="https://chrome.google.com/webstore/detail/techierank-github-stack-o/hafpijmdkicjolibafkgekojggaaicid" target="_blank" rel="noopener noreferrer">AUTOMATE</a><br/><br/></p> */}
        </div>
        <OtherRankingRegister navigateToRegister={navigateToRegister} show_btn_Tag={true} show_a_Tag={false} />
    </section>
    </>
}

export { RecruiterOrEmployerSalesText, RecruiterOrEmployerSalesTitleText};
export default NonLoggedView